import React, { useState } from "react";
import img1 from "../Assets/About/About 1.webp";
import img2 from "../Assets/About/About 2.webp";
import inv1 from "../Assets/About/inv1.webp";
import inv2 from "../Assets/About/inv2.webp";
import inv3 from "../Assets/About/inv3.webp";
import inv4 from "../Assets/About/inv4.webp";

import img9 from "../Assets/Home/009 1.png";
import { Check, Target, Info, PhoneCall, Linkedin } from "react-feather";

import {
  Activity,
  Award,
  ChevronDown,
  ChevronUp,
  Cpu,
  Lock,
} from "react-feather";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import TeamCard from "./card/TeamCard";
import { mentorMembers, teamMembers } from "../utils/data";
function AboutComp() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const accordionData = [
    {
      question: "Is Labops suitable for both pathology and diagnostic labs?",
      answer:
        "Yes, Labops is designed to cater to the needs of both pathology and diagnostic labs, making it a versatile solution for various laboratory settings.",
    },
    {
      question: "How secure is Labops for health data?",
      answer:
        "Labops prioritizes your privacy and security. With end-to-end encryption, HIPAA compliance, and regular audits, your health data is safeguarded with the highest standards.",
    },
    {
      question: "Can I access Labops from mobile devices?",
      answer:
        "Yes, Labops is accessible from both desktop and mobile devices, ensuring you can manage your lab anytime, anywhere.",
    },
    {
      question: "Does Labops support multi-location labs?",
      answer:
        "Absolutely! Labops is equipped to handle multi-location labs efficiently, allowing you to manage all your branches from a single dashboard.",
    },
    {
      question: "Does Labops support multi-location labs?",
      answer:
        "Absolutely! Labops is equipped to handle multi-location labs efficiently, allowing you to manage all your branches from a single dashboard.",
    },
  ];
  return (
    <>
      <div className="bg-gradient-to-l  px-4 xl:px-0  from-white to-blue-50  w-full  pt-[7rem] md:pt-[3rem] py-10 font-sans">
        {/* About Section */}
        <div className="max-w-[81rem] space-y-6 mx-auto">
          <h1 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4">
            About
          </h1>
          <p className="text-gray-800 text-base md:text-lg mb-2">
            Hello everyone!👋
          </p>
          <p className="text-gray-800 text-base md:text-lg mb-4">
            We’re super excited to share what we’ve been working on at Labops.🚀
            <br />
            We’re on a mission to transform healthcare in India — and we’re
            doing it with the power of AI.
          </p>
          <p className="text-gray-800 text-base md:text-lg mb-4">
            Our platform is designed to make healthcare simpler, faster, and
            smarter — whether you’re booking a test, managing reports, or just
            trying to get the right information at the right time. We’re
            building tools that help patients and families spend less time
            worrying and more time healing.
          </p>
          <p className="text-gray-800 text-base md:text-lg pb-4 xl:pb-8">
            Because healthcare shouldn’t be confusing. It should just work.
          </p>

          {/* Office Image */}
          <div className=" rounded-lg overflow-hidden">
            <img
              src={img1} // Replace this with the actual image path
              alt="Office"
              className="w-full object-cover"
            />
          </div>
        </div>

        {/* Vision Section */}
        <div className="max-w-[81rem] mx-auto mt-[2.5rem] md:mt-[5rem] grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div className="space-y-6">
            <h2 className="text-2xl  md:text-4xl font-bold text-gray-900 ">
              Our vision for the future of <br className="hidden md:block" />{" "}
              <span className="block pt-[0.3rem] xl:pt-[0.4rem]">
                {" "}
                AI Healthcare
              </span>
            </h2>
            <p className="text-gray-800 text-base md:text-lg">
              At Labops, we’re building a smarter, AI-powered healthcare system{" "}
              <br />
              — not just for India, but for the world.
              <br />
              <br />
              Our goal is to create tools that support medical professionals
              with faster diagnostics, better decision-making, and more
              personalized care. From answering everyday health queries to
              guiding complex research and analysis, our AI is designed to work
              across the entire healthcare ecosystem.
            </p>
          </div>
          <div className="w-full">
            <img
              src={img2}
              alt="Smiling doctor"
              className="w-full rounded-xl object-cover"
            />
          </div>
        </div>
      </div>
      <section className="w-full h-[22rem] flex   px-4 xl:px-0  items-center justify-center  bg-white">
        <div className="max-w-[81rem] w-full flex flex-col md:flex-row items-center justify-between">
          {/* Left Text */}
          <h2 className="text-2xl md:text-3xl pb-[2rem] xl:pb-0 font-medium text-gray-900 text-center md:text-left">
            We&apos;re funded by top tier <br className="hidden md:block" />{" "}
            investors
          </h2>

          {/* Logos */}
          <div className="flex flex-wrap justify-center items-center gap-x-10 gap-y-6">
            <img
              src={inv1}
              alt="MARL"
              className="w-[8rem] md:w-[10rem] object-contain"
            />
            <img
              src={inv2}
              alt="AWS"
              className="w-[8rem]  md:w-[10rem] bject-contain"
            />
            <img
              src={inv3}
              alt="Microsoft for Startups"
              className="w-[7rem]  md:w-[7rem]  object-contain"
            />
            <img
              src={inv4}
              alt="Google Cloud for Startups"
              className="w-[8rem]  md:w-[10rem] object-contain"
            />
          </div>
        </div>
      </section>
      <div className="bg-gradient-to-l from-white to-blue-50 py-12 px-4 flex flex-col items-center">
        <div className="max-w-[81rem] w-full mx-auto flex flex-col">
          <div className="w-full flex flex-col items-center">
            <span className="text-gray-800 font-semibold pb-[1rem] text-2xl lg:text-4xl">
              Meet Our Team
            </span>
            <span className="text-[#3B3B3B] text-center ">
              Hi, we’re Team Labops 👋 <br /> We’re a passionate group of
              builders, thinkers, and innovators — working to create a smarter,
              AI-powered healthcare ecosystem for the world
            </span>
          </div>

          {/* Swiper for smaller screens */}
          <div className="md:hidden w-full flex justify-center">
            <Swiper
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              spaceBetween={50}
              slidesPerView={1}
              navigation
              centeredSlides={true}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log("slide change")}
            >
              {teamMembers.map((member, index) => (
                <SwiperSlide key={index} className="flex flex-col items-center">
                  <div className="flex justify-center pt-[5rem] ">
                    <img
                      src={member.img}
                      className="w-[13rem] h-[15rem] rounded-md mb-2 "
                      alt={member.name}
                    />
                  </div>

                  <div className="flex flex-col items-center">
                    <span className="text-[1.2rem] font-[500] text-[#3B3B3B]">
                      {member.name}
                    </span>
                    <span className="text-[#6B6B6B]">{member.position}</span>

                    {/* LinkedIn Icon */}
                    <a
                      href={member.linkedInUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Linkedin className="text-[#0072b1] mt-2" size={24} />
                    </a>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className=" md:grid gap-10 px-6 lg:px-20 pt-[5rem] hidden ">
            {/* Top row: 2 members centered */}
            <div className="grid grid-cols-1 sm:grid-cols-2 justify-center gap-10">
              {teamMembers
                .filter((m) => m.executive === true)
                .map((member, index) => (
                  <div key={index} className="flex justify-center">
                    <TeamCard member={member} />
                  </div>
                ))}
            </div>

            {/* Bottom row: 3 aligned cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
              {teamMembers
                .filter((m) => m.executive !== true)
                .map((member, index) => (
                  <div key={index}>
                    <TeamCard member={member} />
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>{" "}
      <div className="bg-gradient-to-l from-white to-blue-50 py-12 px-4 flex flex-col items-center">
        <div className="max-w-[81rem] w-full mx-auto flex flex-col md:gap-y-12">
          <div className="w-full flex flex-col items-center">
            <span className="text-gray-800 font-semibold pb-[1rem] text-2xl lg:text-4xl">
              Meet Our Investors
            </span>
            <span className="text-[#3B3B3B] text-center ">
              Backed by visionary investors who believe in transforming
              healthcare through AI. <br />
              Their support empowers us to build intelligent, accessible, and
              future-ready healthcare solutions for the world.
            </span>
          </div>

          {/* Swiper for smaller screens */}
          <div className="md:hidden w-full flex justify-center">
            <Swiper
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              spaceBetween={50}
              slidesPerView={1}
              navigation
              centeredSlides={true}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log("slide change")}
            >
              {mentorMembers.map((member, index) => (
                <SwiperSlide key={index} className="flex flex-col items-center">
                  <div className="flex justify-center pt-[5rem] ">
                    <img
                      src={member.img}
                      className="w-[13rem] h-[15rem] rounded-md mb-2 "
                      alt={member.name}
                    />
                  </div>

                  <div className="flex flex-col items-center">
                    <span className="text-[1.2rem] font-[500] text-[#3B3B3B]">
                      {member.name}
                    </span>
                    <span className="text-[#6B6B6B]">{member.position}</span>

                    {/* LinkedIn Icon */}
                    <a
                      href={member.linkedInUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Linkedin className="text-[#0072b1] mt-2" size={24} />
                    </a>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Grid layout for larger screens */}

          <div className="md:grid hidden grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
            {mentorMembers
              .filter((m) => m.executive !== true)
              .map((member, index) => (
                <div key={index}>
                  <TeamCard member={member} />
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className="w-full h-full flex flex-col items-center bg-gradient-to-l from-white to-blue-50 py-16 lg:py-16 px-4 md:px-8 lg:px-8 text-[#3B3B3B]">
        <div className="w-full flex max-w-[81rem] flex-col lg:flex-row gap-y-5 gap-x-10 items-start">
          {/* Left Text Section */}
          <div className="lg:flex-1 w-full">
            <div className="w-full flex flex-col gap-y-3">
              <span className="text-[#3B3B3B] text-2xl md:text-4xl font-semibold">
                Frequently Asked Questions
              </span>
              <span className="text-[#6B6B6B] text-lg">
                Get answers to the most commonly asked questions about Labops.
              </span>
            </div>

            {/* Accordion */}
            <div className="mt-8 flex flex-col gap-y-2">
              {accordionData.map((item, index) => (
                <div
                  key={index}
                  className={`border-b-2 border-[#E0E0E0] rounded-xl py-4 transition-all duration-500 ease-in-out ${
                    activeIndex === index
                      ? "bg-white shadow-lg rounded-md"
                      : "bg-white"
                  }`}
                >
                  <div
                    className="flex justify-between items-center px-5 py-2 cursor-pointer transition-transform transform"
                    onClick={() => toggleAccordion(index)}
                  >
                    <span className="text-[#3B3B3B] text-lg font-medium w-[90%]">
                      {item.question}
                    </span>
                    <span className="text-[#6B6B6B] bg-[#D9D9D9] flex justify-center items-center h-[1.6rem] w-[1.6rem] rounded-lg text-xl transition-transform duration-500 ease-in-out">
                      {activeIndex === index ? (
                        <ChevronUp size={20} />
                      ) : (
                        <ChevronDown size={20} />
                      )}
                    </span>
                  </div>

                  {/* Accordion content with smoother transition */}
                  <div
                    className={`overflow-hidden px-5 transition-all duration-700 ease-in-out ${
                      activeIndex === index
                        ? "max-h-[1000px] opacity-100"
                        : "max-h-0 opacity-0"
                    }`}
                    style={{
                      transition:
                        "max-height 0.7s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.7s ease-in-out",
                    }}
                  >
                    <div className="mt-4 text-[#6B6B6B] text-base">
                      <p>{item.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image Section */}
        </div>
      </div>
    </>
  );
}

export default AboutComp;
